<template>
  <v-tooltip top v-if="oferta">
    <template v-slot:activator="{ on }">
      <v-btn small icon v-on="on"
             target="_blank"
             :link="!isMarketplace"
             :href="url">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>
        Abrir oferta
    </span>
  </v-tooltip>
</template>

<script>
const marketplaceUrl = process.env.VUE_APP_MARKETPLACE_APP_URL;

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-open-in-new',
    },
    oferta: {
      type: Object,
      required: true,
    },
    isMarketplace: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    url() {
      return this.isMarketplace ? `${marketplaceUrl}oferta/${this.oferta.id}` : `/ofertas/${this.oferta.id}`;
    },
  },
};
</script>
